import { render, staticRenderFns } from "./SampleAddress.vue?vue&type=template&id=408de9ae"
import script from "./SampleAddress.vue?vue&type=script&lang=js"
export * from "./SampleAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408de9ae')) {
      api.createRecord('408de9ae', component.options)
    } else {
      api.reload('408de9ae', component.options)
    }
    module.hot.accept("./SampleAddress.vue?vue&type=template&id=408de9ae", function () {
      api.rerender('408de9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleAddress.vue"
export default component.exports